import { createRouter, createWebHistory, NavigationGuardWithThis, RouteRecordRaw } from 'vue-router'
import store from './store'

const authGuard: NavigationGuardWithThis<undefined> = async (to, from, next) => {
  try {
    if (!store.state.user) {
      await store.dispatch('getSelfProfile')
    }
  } catch {
    // no user profile
    next({ path: '/index' })
  }
  try {
    if (!store.state.team) {
      // user in a team, get detailed team info
      await store.dispatch('getSelfTeam')
    }
  } finally {
    next()
  }
}

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    component: () => import('./views/Home.vue'),
    redirect: '/index',
    children: [
      {
        path: '/index',
        name: '首页',
        component: () => import('./views/Index.vue')
      },
      {
        path: '/signup',
        name: '报名',
        component: () => import('./views/SignUp.vue')
      },
      {
        path: '/download',
        name: '下载',
        component: () => import('./views/Download.vue')
      },
      {
        path: '/privacy',
        name: '隐私政策',
        component: () => import('./views/Privacy.vue')
      },
      {
        path: '/profile',
        name: '个人信息',
        beforeEnter: authGuard,
        component: () => import('./views/Profile.vue')
      },
      {
        path: '/slides',
        name: 'Keynote',
        component: () => import('./views/Keynote.vue')
      },
      {
        path: '/team',
        name: '队伍管理',
        beforeEnter: [
          authGuard,
          async (to, from, next) => {
            if (!store.state.team && to.path === '/team') {
              // no team
              // Navigate to join/create team
              next({ path: '/team/new' })
            } else {
              next()
            }
          }
        ],
        component: () => import('./views/Team.vue')
      },
      {
        path: '/team/new',
        name: '创建/加入队伍',
        beforeEnter: [
          authGuard,
          async (to, from, next) => {
            if (store.state.team && to.path === '/team/new') {
              // has a team
              // Navigate to team management
              next({ path: '/team' })
            } else {
              next()
            }
          }
        ],
        component: () => import('./views/JoinCreateTeam.vue')
      },
      {
        path: '/team/create',
        name: '创建队伍',
        beforeEnter: [
          authGuard,
          async (to, from, next) => {
            if (store.state.team && to.path === '/team/create') {
              // has a team
              // Navigate to team management
              next({ path: '/team' })
            } else {
              next()
            }
          }
        ],
        component: () => import('./views/CreateTeam.vue')
      },
      {
        path: '/team/join',
        name: '加入队伍',
        beforeEnter: [
          authGuard,
          async (to, from, next) => {
            if (store.state.team && to.path === '/team/create') {
              // has a team
              // Navigate to team management
              next({ path: '/team' })
            } else {
              next()
            }
          }
        ],
        component: () => import('./views/JoinTeam.vue')
      },
      {
        path: '/:pathMatch(.*)*',
        component: () => import('./views/NotFound.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory('/2021/'),
  routes
})

export default router
